// extracted by mini-css-extract-plugin
export default {"link":"MB-z","disabled":"NB-z"};